import { render } from "./DDoctorItem.vue?vue&type=template&id=da2dc080&scoped=true"
import script from "./DDoctorItem.vue?vue&type=script&lang=js"
export * from "./DDoctorItem.vue?vue&type=script&lang=js"

import "./DDoctorItem.vue?vue&type=style&index=0&id=da2dc080&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da2dc080"]])

export default __exports__